import styled from "styled-components";
import Link from 'next/link'

import { FormatDate } from "utils/formatters";

interface Props {
  data: any;
}

const BlogCard = ({data}: Props) => {
  return (
    <Link href={`/makale/${data.slug}`} passHref>
      <Container>
        <ImageContainer>
          <Image src={data.image} alt={data.title} width={300} height={300} />
        </ImageContainer>
        <ContentContainer>
          <ContentTitle>{data.title}</ContentTitle>
          <ContentDateContainer>
            <DateText>{FormatDate(data.createdAt)}</DateText>
            <Link href={data.authorProfile} passHref>
            <a target="_blank" rel="noopener" aria-label="Instagram">
              <AuthorText>{data.authorName}</AuthorText>
            </a>
            </Link>
          </ContentDateContainer>
          <ContentDescription>{data.description}</ContentDescription>
        </ContentContainer>
      </Container>
    </Link>
  )
}

export default BlogCard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 10px 0px;
  cursor: pointer;
`

const ImageContainer = styled.div`
`
const ContentContainer = styled.div`
`
const ContentDateContainer = styled.div`
  margin: 12px 0px;
  display: flex;
  align-items: center;
`

const Image = styled.img`
  width: 100%;
  object-fit: cover;
  height: 200px;
  border-radius: 4px;
`;
const ContentTitle = styled.h3`
  margin: 0px;
  margin-top: 15px;
  color: #132005;
`
const ContentDescription = styled.span`
  color: #132005;
  font-size: 16px;
  line-height: 21px;
`

const DateText = styled.span`
  font-size: 14px;
  color: #191919;
  margin-right: 5px;
`
const AuthorText = styled.span`
  font-size: 14px;
  color: gray;
`